// Brief templates by project type - Shared configuration
// Used in BriefForm, NewProjectRequestPage, and AgencyNewProjectPage

export const briefTemplates = {
  logo: {
    title: 'Brief Création de Logo',
    sections: [
      {
        title: 'Informations générales',
        fields: [
          { name: 'company_name', label: 'Nom de l\'entreprise', type: 'text', required: true },
          { name: 'activity', label: 'Secteur d\'activité', type: 'text', required: true },
          { name: 'target_audience', label: 'Cible / Public visé', type: 'textarea', required: true },
          { name: 'company_values', label: 'Valeurs de l\'entreprise', type: 'textarea', required: true },
        ]
      },
      {
        title: 'Direction artistique',
        fields: [
          { name: 'style', label: 'Style souhaité', type: 'select', options: ['Moderne', 'Classique', 'Minimaliste', 'Ludique', 'Premium', 'Autre'], required: true },
          { name: 'colors', label: 'Couleurs souhaitées', type: 'text', placeholder: 'Ex: Bleu marine, Or' },
          { name: 'avoid_colors', label: 'Couleurs à éviter', type: 'text' },
          { name: 'inspirations', label: 'Logos inspirants (liens ou descriptions)', type: 'textarea' },
          { name: 'competitors', label: 'Logos de concurrents à éviter', type: 'textarea' },
        ]
      },
      {
        title: 'Utilisation',
        fields: [
          { name: 'usage_web', label: 'Site web', type: 'checkbox' },
          { name: 'usage_print', label: 'Impression (cartes, flyers)', type: 'checkbox' },
          { name: 'usage_signage', label: 'Signalétique / Enseigne', type: 'checkbox' },
          { name: 'usage_vehicle', label: 'Véhicules', type: 'checkbox' },
          { name: 'usage_clothing', label: 'Vêtements / Textile', type: 'checkbox' },
          { name: 'special_requirements', label: 'Exigences particulières', type: 'textarea' },
        ]
      }
    ]
  },
  visual: {
    title: 'Brief Création Visuelle',
    sections: [
      {
        title: 'Contexte',
        fields: [
          { name: 'project_context', label: 'Contexte du projet', type: 'textarea', required: true },
          { name: 'objective', label: 'Objectif de la création', type: 'textarea', required: true },
          { name: 'target_audience', label: 'Public cible', type: 'textarea', required: true },
        ]
      },
      {
        title: 'Spécifications techniques',
        fields: [
          { name: 'format', label: 'Format(s) souhaité(s)', type: 'select', options: ['Affiche A4', 'Affiche A3', 'Bannière web', 'Post réseaux sociaux', 'Flyer', 'Autre'], required: true },
          { name: 'dimensions', label: 'Dimensions spécifiques', type: 'text', placeholder: 'Ex: 1920x1080px' },
          { name: 'quantity', label: 'Nombre de visuels', type: 'number', required: true },
        ]
      },
      {
        title: 'Direction créative',
        fields: [
          { name: 'style', label: 'Style graphique', type: 'select', options: ['Photo-réaliste', 'Illustration', 'Minimaliste', 'Corporate', 'Créatif', 'Autre'] },
          { name: 'mood', label: 'Ambiance / Mood', type: 'textarea' },
          { name: 'mandatory_elements', label: 'Éléments obligatoires', type: 'textarea', placeholder: 'Logo, texte, images...' },
          { name: 'text_content', label: 'Texte à intégrer', type: 'textarea' },
        ]
      }
    ]
  },
  video: {
    title: 'Brief Production Vidéo',
    sections: [
      {
        title: 'Informations projet',
        fields: [
          { name: 'video_type', label: 'Type de vidéo', type: 'select', options: ['Corporate', 'Publicitaire', 'Tutoriel', 'Interview', 'Événementiel', 'Animation', 'Autre'], required: true },
          { name: 'objective', label: 'Objectif de la vidéo', type: 'textarea', required: true },
          { name: 'target_audience', label: 'Public cible', type: 'textarea', required: true },
          { name: 'key_message', label: 'Message clé à faire passer', type: 'textarea', required: true },
        ]
      },
      {
        title: 'Spécifications techniques',
        fields: [
          { name: 'duration', label: 'Durée souhaitée', type: 'select', options: ['15 secondes', '30 secondes', '1 minute', '2-3 minutes', '5+ minutes'], required: true },
          { name: 'format', label: 'Format de diffusion', type: 'select', options: ['16:9 (Horizontal)', '9:16 (Vertical/Stories)', '1:1 (Carré)', 'Multiple'], required: true },
          { name: 'platforms', label: 'Plateformes de diffusion', type: 'textarea', placeholder: 'YouTube, Instagram, Site web...' },
        ]
      },
      {
        title: 'Contenu',
        fields: [
          { name: 'script_provided', label: 'Script fourni', type: 'checkbox' },
          { name: 'voiceover', label: 'Voix off souhaitée', type: 'checkbox' },
          { name: 'music', label: 'Musique/Sound design', type: 'select', options: ['Fournie par le client', 'À rechercher (libre de droits)', 'Création originale'] },
          { name: 'footage', label: 'Images/Vidéos existantes à utiliser', type: 'textarea' },
          { name: 'references', label: 'Vidéos de référence (liens)', type: 'textarea' },
        ]
      }
    ]
  },
  website: {
    title: 'Brief Site Internet',
    sections: [
      {
        title: 'Informations générales',
        fields: [
          { name: 'site_type', label: 'Type de site', type: 'select', options: ['Vitrine', 'E-commerce', 'Blog', 'Portfolio', 'Application web', 'Landing page'], required: true },
          { name: 'objective', label: 'Objectif principal du site', type: 'textarea', required: true },
          { name: 'target_audience', label: 'Public cible', type: 'textarea', required: true },
          { name: 'existing_site', label: 'URL du site actuel (si refonte)', type: 'text' },
        ]
      },
      {
        title: 'Structure & Contenu',
        fields: [
          { name: 'pages', label: 'Pages souhaitées', type: 'textarea', placeholder: 'Accueil, À propos, Services, Contact...', required: true },
          { name: 'features', label: 'Fonctionnalités spécifiques', type: 'textarea', placeholder: 'Formulaire, Blog, Espace membre...' },
          { name: 'content_provided', label: 'Contenu fourni (textes, images)', type: 'checkbox' },
          { name: 'multilingual', label: 'Site multilingue', type: 'checkbox' },
        ]
      },
      {
        title: 'Design & Technique',
        fields: [
          { name: 'design_style', label: 'Style de design', type: 'select', options: ['Moderne', 'Minimaliste', 'Corporate', 'Créatif', 'E-commerce'] },
          { name: 'inspirations', label: 'Sites d\'inspiration', type: 'textarea' },
          { name: 'hosting', label: 'Hébergement souhaité', type: 'select', options: ['À définir', 'Hébergement existant', 'Nouveau hébergement'] },
          { name: 'domain', label: 'Nom de domaine', type: 'text', placeholder: 'www.exemple.com' },
          { name: 'seo', label: 'Optimisation SEO souhaitée', type: 'checkbox' },
        ]
      }
    ]
  },
  mobile_app: {
    title: 'Brief Application Mobile',
    sections: [
      {
        title: 'Vision du projet',
        fields: [
          { name: 'app_concept', label: 'Concept de l\'application', type: 'textarea', required: true },
          { name: 'problem_solved', label: 'Problème résolu', type: 'textarea', required: true },
          { name: 'target_users', label: 'Utilisateurs cibles', type: 'textarea', required: true },
          { name: 'competitors', label: 'Applications concurrentes', type: 'textarea' },
        ]
      },
      {
        title: 'Spécifications',
        fields: [
          { name: 'platforms', label: 'Plateformes', type: 'select', options: ['iOS uniquement', 'Android uniquement', 'iOS + Android'], required: true },
          { name: 'core_features', label: 'Fonctionnalités principales', type: 'textarea', required: true },
          { name: 'user_accounts', label: 'Comptes utilisateurs', type: 'checkbox' },
          { name: 'payments', label: 'Paiements in-app', type: 'checkbox' },
          { name: 'notifications', label: 'Notifications push', type: 'checkbox' },
          { name: 'offline_mode', label: 'Mode hors-ligne', type: 'checkbox' },
        ]
      },
      {
        title: 'Design & UX',
        fields: [
          { name: 'design_style', label: 'Style de design', type: 'select', options: ['iOS natif', 'Material Design', 'Custom', 'Minimaliste'] },
          { name: 'branding', label: 'Charte graphique existante', type: 'checkbox' },
          { name: 'inspirations', label: 'Applications d\'inspiration', type: 'textarea' },
        ]
      }
    ]
  },
  ecommerce: {
    title: 'Brief E-commerce',
    sections: [
      {
        title: 'Informations générales',
        fields: [
          { name: 'products_type', label: 'Type de produits', type: 'text', required: true },
          { name: 'products_count', label: 'Nombre de produits estimé', type: 'select', options: ['1-50', '50-200', '200-1000', '1000+'], required: true },
          { name: 'target_market', label: 'Marché cible', type: 'textarea', required: true },
          { name: 'existing_site', label: 'Site actuel (si existant)', type: 'text' },
        ]
      },
      {
        title: 'Fonctionnalités',
        fields: [
          { name: 'payment_methods', label: 'Moyens de paiement', type: 'textarea', placeholder: 'CB, PayPal, virement...' },
          { name: 'shipping', label: 'Options de livraison', type: 'textarea' },
          { name: 'user_accounts', label: 'Comptes clients', type: 'checkbox' },
          { name: 'reviews', label: 'Avis clients', type: 'checkbox' },
          { name: 'wishlist', label: 'Liste de souhaits', type: 'checkbox' },
          { name: 'promotions', label: 'Codes promo / Soldes', type: 'checkbox' },
        ]
      },
      {
        title: 'Design & Technique',
        fields: [
          { name: 'platform', label: 'Plateforme préférée', type: 'select', options: ['Shopify', 'WooCommerce', 'PrestaShop', 'Sur mesure', 'Pas de préférence'] },
          { name: 'design_style', label: 'Style de design', type: 'select', options: ['Moderne', 'Minimaliste', 'Luxe', 'Fun/Coloré'] },
          { name: 'inspirations', label: 'Sites e-commerce d\'inspiration', type: 'textarea' },
        ]
      }
    ]
  },
  marketing: {
    title: 'Brief Marketing / Publicité',
    sections: [
      {
        title: 'Objectifs',
        fields: [
          { name: 'campaign_objective', label: 'Objectif de la campagne', type: 'select', options: ['Notoriété', 'Génération de leads', 'Ventes', 'Trafic', 'Engagement'], required: true },
          { name: 'target_audience', label: 'Audience cible', type: 'textarea', required: true },
          { name: 'key_message', label: 'Message clé', type: 'textarea', required: true },
          { name: 'call_to_action', label: 'Call-to-action souhaité', type: 'text' },
        ]
      },
      {
        title: 'Canaux & Budget',
        fields: [
          { name: 'channels', label: 'Canaux de diffusion', type: 'textarea', placeholder: 'Facebook, Instagram, Google Ads, LinkedIn...' },
          { name: 'budget_ads', label: 'Budget publicitaire mensuel', type: 'select', options: ['< 500€', '500-2000€', '2000-5000€', '5000-10000€', '> 10000€'] },
          { name: 'campaign_duration', label: 'Durée de la campagne', type: 'select', options: ['Ponctuelle', '1 mois', '3 mois', '6 mois', '12 mois'] },
        ]
      },
      {
        title: 'Créatifs',
        fields: [
          { name: 'visuals_needed', label: 'Visuels à créer', type: 'textarea', placeholder: 'Bannières, posts, vidéos...' },
          { name: 'existing_assets', label: 'Assets existants', type: 'checkbox' },
          { name: 'brand_guidelines', label: 'Charte graphique fournie', type: 'checkbox' },
          { name: 'references', label: 'Campagnes de référence', type: 'textarea' },
        ]
      }
    ]
  },
  other: {
    title: 'Brief Projet',
    sections: [
      {
        title: 'Description du projet',
        fields: [
          { name: 'project_description', label: 'Décrivez votre projet en détail', type: 'textarea', required: true },
          { name: 'objective', label: 'Objectif principal', type: 'textarea', required: true },
          { name: 'target_audience', label: 'Public cible', type: 'textarea' },
          { name: 'references', label: 'Références ou inspirations', type: 'textarea' },
          { name: 'constraints', label: 'Contraintes particulières', type: 'textarea' },
        ]
      }
    ]
  }
};

// Helper to get template by project type
export const getTemplateByType = (projectType) => {
  return briefTemplates[projectType] || briefTemplates.other;
};

// Helper to get all field names for a project type
export const getFieldNames = (projectType) => {
  const template = getTemplateByType(projectType);
  const fields = [];
  template.sections.forEach(section => {
    section.fields.forEach(field => {
      fields.push(field.name);
    });
  });
  return fields;
};

export default briefTemplates;
